import { z } from 'zod';
import { isMongoId } from '../../helpers';
import { CalendarDay } from '../../../utils';

const SupportingFileSchema = z.object({
  name: z.string().min(1, 'File name is required'),
  path: z.string().min(1, 'File path is required'),
});

const ExitStatementDataSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  summary: z.string().min(1, 'Summary is required'),
  letter: z.string().min(1, "Manager's letter is required"),
  notes: z.string().optional(),
  supportingFiles: z.array(SupportingFileSchema).optional().default([]),
  notifyInvestors: z.boolean().default(false),
  statementDate: z.instanceof(CalendarDay),
  includePreviousExitStatements: z.boolean().optional(),
});

export const CreateExitStatementInput = z.object({
  exitId: z.string().refine(isMongoId(), {
    message: 'Invalid exit ID',
  }),
  exitAmendmentId: z
    .string()
    .refine(isMongoId(), {
      message: 'Invalid exit amendment ID',
    })
    .optional(),
  data: ExitStatementDataSchema,
});

export const UpdateExitStatementInput = z.object({
  exitStatementId: z.string().refine(isMongoId(), {
    message: 'Invalid exit statement ID',
  }),
  data: ExitStatementDataSchema,
});

export const GetExitStatementInput = z.object({
  exitStatementId: z.string().refine(isMongoId(), {
    message: 'Invalid exit statement ID',
  }),
});

export const DeleteExitStatementInput = z.object({
  exitStatementId: z.string().refine(isMongoId(), {
    message: 'Invalid exit statement ID',
  }),
});

export const ExportExitStatementPdfInput = z.object({
  exitStatementId: z.string().refine(isMongoId(), {
    message: 'Invalid exit statement ID',
  }),
  investorId: z.string().refine(isMongoId(), {
    message: 'Invalid investor ID',
  }),
});

export const DownloadSupportingFileInput = z.object({
  exitStatementId: z.string().refine(isMongoId(), {
    message: 'Invalid exit statement ID',
  }),
  filePath: z.string().min(1, 'File path is required'),
});

export const GetExitStatementForInvestorInput = z.object({
  exitStatementId: z.string().refine(isMongoId(), {
    message: 'Invalid exit statement ID',
  }),
});

export const GetExitStatementSampleUrlInput = z.object({
  exitId: z.string().refine(isMongoId(), {
    message: 'Invalid exit ID',
  }),
  exitAmendmentId: z
    .string()
    .refine(isMongoId(), {
      message: 'Invalid exit amendment ID',
    })
    .optional(),
  data: ExitStatementDataSchema,
  previewPdf: z.boolean().default(true),
});

export const GetDraftExitStatementInput = z.object({
  exitId: z.string().refine(isMongoId(), {
    message: 'Invalid exit ID',
  }),
  exitAmendmentId: z
    .string()
    .refine(isMongoId(), {
      message: 'Invalid exit amendment ID',
    })
    .optional(),
});

export const GetPreviousExitStatementInput = z.object({
  exitId: z.string().refine(isMongoId(), {
    message: 'Invalid exit ID',
  }),
});
